import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import Backend from 'i18next-http-backend';

i18n.use(initReactI18next).use(Backend).init({
  debug: true,
  lng: localStorage.getItem('i18nextLng') ?? (['zh-HK', 'zh-TW', 'zh'].includes(window.navigator.language) ? "zh" : ['zh-CN'].includes(window.navigator.language)? "ch" : "en"),
  fallbackLng: 'en',
  returnObjects: true,
});